import React from "react";
import { footColumns, otherColumns } from "../utlils/reportData";
import ReactExport from "react-data-export";
import moment from "moment";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const DownLoadCSV = ({ rdata }) => {
  const currency = localStorage.getItem("currency");

  const footPrintData = [
    {
      columns: footColumns,
      data:
        rdata.length > 0 &&
        rdata.map((order, index) => {
          return [
            { value: order.job_id ? order.job_id : "" },
            { value: order.job_address ? order.job_address : "" },
            {
              value: order.job_date
                ? moment(order.job_date).format("DD/MM/YYYY")
                : "",
            },
            { value: order.service_name ? order.service_name : "" },
            {
              value: order.ewc_code ? order.ewc_code : "",
            },
            {
              value: order.transaction_cost ? `${currency?currency:'£'}` + order.transaction_cost : "",
            },
            {
              value: String(order.full_name),
              ...(order.full_name == "Average"
                ? {
                  style: {
                    font: { sz: "10", bold: true },
                    fill: {
                      patternType: "solid",
                      fgColor: { rgb: "52a9dd" },
                    },
                  },
                }
                : order.full_name
                  ? String(order.full_name)
                  : ""),
            },
            {
              value: order.co2_emissions
                ? order.co2_emissions + "2"
                : order.WTN_number
                  ? order.WTN_number + " kg CO2"
                  : "",
            },
          ];
        }),
    },
  ];
  const data = [
    {
      columns: otherColumns,
      data:
        rdata.length > 0 &&
        rdata.map((order, index) => {
          return [
            { value: order.job_id ? order.job_id : "" },
            { value: order.job_address ? order.job_address : "" },
            {
              value: order.job_date
                ? moment(order.job_date).format("DD/MM/YYYY")
                : "",
            },
            { value: order.service_name ? order.service_name : "" },
            {
              value: order.ewc_code,
              ...(order.ewc_code === "Sub Total"
                ? {
                  style: {
                    font: { sz: "10", bold: true },
                    fill: {
                      patternType: "solid",
                      fgColor: { rgb: "52a9dd" },
                    },
                  },
                }
                : order.ewc_code
                  ? order.ewc_code
                  : ""),
            },
            {
              value: order.transaction_cost ? `${currency?currency:'£'}` + order.transaction_cost : "",
            },
            {
              value: String(order.full_name) ? String(order.full_name) : "",
            },
            {
              value: order.WTN_number ? `${currency?currency:'£'}` + order.WTN_number : "",
            },
            {
              value: order.disposal_site ? order.disposal_site : "",
            },
            { value: order.tonnage ? order.tonnage : "" },
            {
              value: order.diverted_tonnage ? order.diverted_tonnage : "",
            },
            { value: order.Volume ? order.Volume : "" },
            {
              value: order.Landfill_Diversion_Rate
                ? order.Landfill_Diversion_Rate
                : "",
            },
          ];
        }),
    },
  ];
  return (
    <div>
      <ExcelFile element={<button>Download Reports</button>} filename="reports">
        <ExcelSheet
          dataSet={
            rdata[rdata.length - 1].transaction_cost ? data : footPrintData
          }
          name="Organization"
        />
      </ExcelFile>
    </div>
  );
};

export default DownLoadCSV;
